import React, { useEffect, useState } from 'react';
import { IUser } from '../../../model/user/IUser';
import { Card, Dropdown, DropdownButton, Table } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { CompanyService } from '../CompanyService';
import { ErrorToast } from '../../../utils/toasters';
import { getCorrectEnums } from '../../../utils/Functions';
import { ImpersonateEye } from '../../../shared/components/ImpersonateEye';
import { CustomImageHandler } from '../../../shared/components/img/CustomImageHandler';

export function CompanyUsers() {
    const [users, setUsers] = useState<IUser[]>([]);
    const { id }: any = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        CompanyService.getCompanyUsers(id)
            .then(data => {
                setUsers(data);
            })
            .catch(err => {
                ErrorToast(err);
            });
    }, []);

    return (
        <Card className="mb-5 p-4">
            <Table hover responsive>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Photo</th>
                        <th>Display name</th>
                        <th>Type</th>
                        <th>Email</th>
                        <th>Managing</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(e => (
                        <tr key={e.id}>
                            <td>{e.id}</td>
                            <td>
                                <CustomImageHandler
                                    altTag="user-photo"
                                    classes="rounded-circle"
                                    thumbnailPath={e?.profilePhoto?.thumbnail ?? ''}
                                    photoPath={e?.profilePhoto?.thumbnail ?? ''}
                                    style={{ width: 50, height: 50 }}
                                />
                            </td>
                            <td>
                                {e.displayName}
                                {!!e.displayName && <br />}
                                {e.firstName} {e.lastName}
                            </td>
                            <td>{getCorrectEnums(e.userType ?? '')}</td>
                            <td>
                                <ImpersonateEye id={e.id ?? 0} />
                                {e.email}
                            </td>
                            {/*<td>{e.lastLogin}<br/> IP:{e.lastLoginIp}</td>*/}
                            <td>{e?.assignedCampaigns?.length || 0}</td>
                            <td>
                                <DropdownButton title="Actions" id="dropdown-menu-align-right">
                                    <Dropdown.Item as="div" onClick={() => navigate(`/user/edit/${e.id}`)}>
                                        Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item>{e.isEnabled ? 'Disable' : 'Enable'}</Dropdown.Item>
                                </DropdownButton>
                            </td>
                        </tr>
                    ))}
                    {users.length < 15 && !!users.length && (
                        <tr>
                            <td colSpan={99} style={{ height: '180px' }} />
                        </tr>
                    )}
                </tbody>
            </Table>
        </Card>
    );
}
